export const ONBOARDING_INFO = "storeHeroOnboardingInfo";

export const GOOGLE_ADS_CARDS = "google-cards-to-show";
export const FACEBOOK_ADS_CARDS = "facebook-cards-to-show";
